import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import {
  useLeft,
  useLeftList,
  useLeftSelected,
  useNewNotice,
  useNewNoticeCheckInit,
  useSecList,
  useSelectSideNav,
  useSidebarChannelPop,
  useTopSelected,
  useUserProfileCheck,
  useUserProfileNewWrite,
} from "store/modules/navigates/navigatesHook";
import { LEFT, type INavigatesVO, SEC } from "store/modules/navigates/navigateVo";
import useAuth from "store/modules/auth/authHook";
import SVG from "commons/styles/svgIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { Grade } from "store/modules/auth/authVo";
import Joyride, { type CallBackProps, type Step } from "react-joyride";
import Button from "components/ui/Button";
import { ElementGroup } from "styles/components";
import UiInputText from "commons/components/ui/UiInputText";

import { useDispatch } from "react-redux";
import { rdxSetChannelSelect } from "store/modules/navigates/navigatesR";
import { useCalculateCompanyDataPopup } from "components/popup/calculate/company/DataDownHook";
import { rdxPopupOpen } from "commons/popup/store/popupR";
import { PopupType } from "components/popup/PopupType";
import { PopupFooter } from "components/popup/uiux/UpdatePopup";

const NavWrap = styled.nav<{ active: boolean }>`
  display: flex;
  align-items: flex-start;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 8;
  width: auto;
  height: 100%;
`;
const Lnb = styled.div`
  position: relative;
  width: 60px;
  height: 100%;
  z-index: 10; /* Ensure Lnb is on top */
  border-right: 1px solid var(--border-normal);
  background-color: #eaedf0;

  .lnb_menu {
    width: 100%;
    margin: 15px 0 30px;
    padding: 0;

    &::before {
      margin-right: 0;
    }
  }
`;
const Snb = styled.div<{ active: boolean }>`
  width: ${props => (props.active ? "240px" : "0")};
  right: ${props => (props.active ? "0" : "300px")};
  opacity: ${props => (props.active ? "1" : "0")};
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  position: relative;
  height: 100%;
  background-color: #f9fafc;
  border-right: 1px solid var(--border-normal);
  z-index: 9;
`;

const Lnb2ItemLink = styled.span<{ menuId: string; active?: boolean; disabled?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  ${props => (props.active === true ? "font-weight: 600;" : "")}

  &::before {
    content: "";
    width: 36px;
    height: 36px;
    border-radius: 4px;
    background-image: ${props => {
      return props.active === true
        ? `url("/icon/new/menu/${props.menuId.toLocaleLowerCase()}_active.svg")`
        : `url("/icon/new/menu/${props.menuId.toLocaleLowerCase()}.svg")`;
    }};
    background-size: 24px;
    background-position: center;
    background-repeat: no-repeat;
  }

  &:hover {
    /* font-weight: 600; */
    color: #999;
  }
`;

const LnbItemLinkCon = styled.div`
  position: relative;
  margin: 0 auto;
  width: 42px;
  height: 58px;
`;
const NavMenuWrapper = styled.div<{ active: boolean }>`
  width: 100%;
  position: relative;

  border-radius: 4px;
  ${props => (props.active === true ? "background-color: rgba(175, 181, 194, 0.3)" : "")};
  margin-bottom: 18px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const LnbScroll = styled.div`
  overflow: auto;
  flex-wrap: nowrap;
  align-self: stretch;
  width: 100%;
`;

const SubLnbContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const SubHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  width: 100%;
  height: 56px;
  border-bottom: 1px solid var(--border-normal);
  cursor: pointer;

  .company_logo {
    margin: 0;
    border-radius: 8px;
    border: 1px solid var(--border-normal);
    width: 36px;
    height: 36px;
  }
`;
const ChannelSideBar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div {
    display: flex;
    gap: 8px;
    .sidebar__info {
      position: relative;
      > div {
        display: block;
        &:first-child {
          p {
            width: 140px;
            color: #161c1c;
            font-size: 16px;
            font-weight: 700;

            display: block; /* 블록태그로 만들어준다 */
            text-overflow: ellipsis; /* 말줄임 css */
            white-space: nowrap; /*글자를 한줄로 모아준다*/
            overflow: hidden;
          }
        }
        &:last-child {
          color: #444;
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
  }

  &::after {
    content: "";
    display: inline-block;
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url("/icon/new/sidebar_updown.svg");
    width: 12px;
    height: 24px;
    background-size: 20px;
  }
`;

const SubNavMenuWrap = styled.div`
  width: 100%;
  padding: 12px 16px;
`;

const SubNavMenuLi = styled.li<{ isActive: boolean; iconName: string }>`
  display: flex;
  width: 100%;
  height: 36px;
  padding: 8px 15px;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
  cursor: pointer;

  ${props =>
    props.isActive === true &&
    `    border-radius: 6px;
background: rgba(175, 181, 194, 0.35);
    font-weight: 600;`}

  span {
    display: flex;
    align-items: center;
    /* ${props => props.isActive === true && `color: var(--primary);`} */
    &::before {
      content: "";
      width: 18px;
      height: 18px;
      display: inline-block;
      background-position: center center;
      background-repeat: no-repeat;

      background-image: ${props => {
        switch (props.iconName) {
          // case SEC.TRANSLATE_LIST:
          //   return `url("/icon/new/menu/${props.isActive === true ? "home_active" : "home"}.svg")`;
          // case SEC.TRANSLATE_MANAGE:
          //   return `url("/icon/new/menu/${
          //     props.isActive === true ? "channel_setting_active" : "channel_setting"
          //   }.svg")`;
          default:
            return props.isActive === true
              ? `url("/icon/new/menu/${props.iconName}_active.svg")`
              : `url("/icon/new/menu/${props.iconName}.svg")`;
            break;
        }
      }};

      margin-right: 8px;
      background-size: 100%;
    }
  }

  &:hover {
    font-weight: 600;
    /* color: var(--primary); */
  }
`;

const PopupChannelMenu = styled.div<{ open: boolean }>`
  display: ${props => (props.open === true ? "block" : "none")};
  position: absolute;
  left: 8px;
  top: 66px;
  width: 300px;
  height: 270px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 1px 1px 10px 10px rgb(110 110 110 / 10%);
  .search_wrap {
    display: flex;
    width: 100%;
    border-radius: 8px;
    background: #f0f1f4;
    border: none;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    &::before {
      content: "";
      width: 18px;
      height: 18px;
      background-image: url(${SVG.Search("#444")});
    }
    input#sidebar_channel_pop_menu {
      border: none;
      background-color: #f0f1f4;
    }
  }

  .channel_list_wrap {
    margin-top: 15px;
    height: 200px;
    overflow-y: scroll;
    li {
      padding: 8px 12px;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      align-items: start;

      span {
        display: inline-block;
        height: 23px;
        white-space: nowrap;
        font-size: 0.7rem;
        margin-right: 8px;
        border-radius: 6px;
        padding: 0 6px;
        font-weight: 600;
        background-color: #fff;
        border: 1px solid #222;
        &.provider {
          background-color: #5961da17;
          border: 1px solid var(--primary);
          color: var(--primary);
        }
        &.media {
          background-color: #e54c9617;
          color: #e54c95;
          border: 1px solid #e54c95;
        }
        &.partners {
          background-color: #02a9b217;
          color: #02a9b2;
          border: 1px solid #02a9b2;
        }
      }

      &:hover {
        background-color: #f4f7f9;
      }
      &.active {
        background: var(--bg-light-gray);
      }
    }
  }
`;

const CompanyDetailDataWrap = styled.div`
  width: 80%;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);

  button {
    &::before {
      background-color: #2c3030;
      border-radius: 6px;
      width: 28px;
      height: 27px;
      margin-right: 10px;
      background-size: 10px;
    }
    width: 100%;
    color: #444444;
    font-weight: 500;
    font-size: 1.1rem;
    padding: 8px 0;

    &:hover {
      font-weight: 600;
      color: #444444;
      background-color: var(--bg-light-gray);
    }
  }
`;

/**
 * 채널 선택 팝업 메뉴
 * @returns
 */
function ChannelPopupSubMenu(props: { role: string }) {
  useSidebarChannelPop();
  const dispatch = useDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const [search, setSearch] = useState<string | undefined>(undefined);
  const { managerName } = useAuth();

  const { channelList, selectChannel } = useSelectSideNav();

  const list =
    search !== undefined
      ? channelList?.filter(i => i.text.toLocaleLowerCase().indexOf(search as string) > -1)
      : channelList;

  const select = (idx: number) => {
    setOpen(false);
    dispatch(rdxSetChannelSelect(list![idx]));
  };

  return (
    <SubLnbContainer>
      <SubHeader onClick={() => setOpen(!open)}>
        <ChannelSideBar>
          <div>
            <img
              className="company_logo"
              alt="회사 로고"
              src={
                selectChannel === undefined
                  ? props.role === Grade.MASTER
                    ? "/images/fastview_logo_bar.png"
                    : "/images/default_logo.png"
                  : selectChannel.logo
                  ? selectChannel.logo
                  : "/images/default_logo.png"
              }
            />
            <div className="sidebar__info">
              <div>
                <p>{selectChannel ? selectChannel.text : managerName}</p>
              </div>
              <div>운영중인 채널 {channelList ? channelList.length - 1 : 0}개</div>
            </div>
          </div>
        </ChannelSideBar>
      </SubHeader>

      <PopupChannelMenu open={open}>
        <div className="search_wrap">
          <UiInputText
            id="sidebar_channel_pop_menu"
            placeholder="브랜드 검색"
            change={v => setSearch(v.value?.toLocaleLowerCase())}
          />
        </div>
        <div className="channel_list_wrap">
          <ul>
            {list &&
              list.map((i, idx) => {
                return (
                  <li
                    key={idx}
                    className={selectChannel ? (idx === selectChannel.id ? "active" : "") : idx === 0 ? "active" : ""}
                    onClick={() => select(idx)}
                  >
                    {i.type !== undefined && (
                      <span className={i.type?.toLocaleLowerCase()}>
                        {i.type === "PROVIDER" ? "콘텍스트" : i.type === "MEDIA" ? "음원" : "파트너스"}
                      </span>
                    )}
                    {i.text}
                  </li>
                );
              })}
          </ul>
        </div>
      </PopupChannelMenu>
    </SubLnbContainer>
  );
}
function SubNavManu(props: { sTop: string }) {
  const nav = useNavigate();

  const sec = useSecList(props.sTop);
  const loc = useLocation();
  return (
    sec && (
      <SubNavMenuWrap>
        <ul>
          {sec.map((s, idx) => {
            return (
              <SubNavMenuLi
                key={idx + 1}
                isActive={s.router === loc?.pathname}
                iconName={s.id}
                onClick={() => {
                  nav(s.router);
                }}
              >
                <span>{s.name}</span>
              </SubNavMenuLi>
            );
          })}
        </ul>
      </SubNavMenuWrap>
    )
  );
}

function CalculateMasterBtn() {
  const { popupOpen } = useCalculateCompanyDataPopup();
  return (
    <CompanyDetailDataWrap>
      <Button
        btnType="ghost"
        iconName="Download"
        iconPosition="before"
        color="white"
        btnSize={"sm"}
        text="업체별 상세 데이터"
        onClick={popupOpen}
      />
    </CompanyDetailDataWrap>
  );
}

/**
 * 소분류 메뉴
 * @param props
 * @returns
 */
function SideBarNav(props: { active: boolean; sTop: string; role: string }) {
  return (
    <Snb active={props.active}>
      <ChannelPopupSubMenu role={props.role} />
      <SubNavManu sTop={props.sTop} />
      {props.sTop === LEFT.CALCULATE && props.role === Grade.MASTER && <CalculateMasterBtn />}
    </Snb>
  );
}
function LnbItemLink(props: { key: string; item: INavigatesVO; sTop: string }): JSX.Element {
  const { setLeft } = useLeftSelected();

  return (
    <NavMenuWrapper active={props.item.id === props.sTop}>
      <LnbItemLinkCon>
        <Lnb2ItemLink
          menuId={props.item.id}
          active={props.item.id === props.sTop}
          disabled={props.item.disabled}
          onClick={setLeft.bind(null, props.item)}
        >
          {props.item.name}
        </Lnb2ItemLink>
      </LnbItemLinkCon>
    </NavMenuWrapper>
  );
}

const LnbItemLinkMemo = React.memo(LnbItemLink);

function Nav(): JSX.Element {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { role, service_type, guideFlag } = useAuth();
  const { isLeft, activeLeft } = useLeft();
  const { leftList, flag } = useLeftList();
  useNewNotice();
  useUserProfileCheck(role);

  const getTopSelected = useTopSelected();
  const sTop = getTopSelected();
  const sec = useSecList(sTop);

  //해당 계정이 번역 관련 계정인지 아닌지 여부
  const translateFlag = service_type && service_type.indexOf("TRANSLATE") > -1 ? true : false;

  // useEffect(() => {
  //   if (role !== Grade.MASTER && flag === false && !translateFlag) {
  //     console.log("프로필 안함");
  //     navigate("/admin/setting");
  //   }
  // }, [flag]);

  const sideActive = () => {
    activeLeft(!isLeft);
  };

  useEffect(() => {
    if (sec && sec.length > 0) {
      activeLeft(true);
    } else {
      activeLeft(false);
    }
  }, [sec]);

  useEffect(() => {
    if (guideFlag === false) {
      dispatch(
        rdxPopupOpen({
          width: 640,
          type: PopupType.UIUX_UPDATE_POPUP,
          buttonWrapper: PopupFooter,
        }),
      );
    }
  }, [guideFlag]);

  return (
    <NavWrap active={isLeft}>
      <Lnb>
        <Button
          className="lnb_menu"
          btnSize={"sm"}
          btnType="ghost"
          color={"dark"}
          iconPosition="before"
          iconName="Hamburger"
          onClick={() => {
            if (sec && sec.length > 0) {
              sideActive();
            }
          }}
        />
        <LnbScroll>
          {leftList.map(list => (
            <LnbItemLinkMemo key={list.id} item={list} sTop={sTop} />
          ))}
        </LnbScroll>
      </Lnb>

      {/* 사이드바 */}
      {sec && <SideBarNav active={isLeft} sTop={sTop} role={role} />}
    </NavWrap>
  );
}

export default Nav;
